import React, { useEffect, useState } from 'react';
import BookDetails from './BookDetails.tsx';
import { BookingModel } from '../ts/PackageResponse.tsx';
import { useGetPage } from '../hooks/useGetPage.ts';
import { getPage, PageItem } from '@bepro-travel/fe.shared';
import { useTranslation } from 'react-i18next';

const SuccessPage = () => {
  const [order, setOrder] = useState<BookingModel>();
  const [data, setData] = useState<PageItem>();
  const { t } = useTranslation();
  useGetPage('');

  useEffect(() => {
    const selectedOrder = sessionStorage.getItem('orderSuccess');
    if (selectedOrder) {
      const newOrder = JSON.parse(selectedOrder);
      setOrder(newOrder);
    }

    (async () => {
      const newdata = await getPage('pages/success');
      const pageItem = newdata?.pageItems.find(
        (pi) => pi.cmsAttribute === 'cmsContent_1'
      );
      setData(pageItem);
    })();
  }, []);

  return (
    <div className="mt-10 flex-column rtl">
      <p className="home-titles">
        תודה שבחרתם במחלקת ויזות של אמסלם תיירות ונופש
      </p>
      <div className="title text-center mt-20">
        {t('order_summary')} #{order?.order?.orderId}
      </div>
      <div className="pac-wr">
        {' '}
        <div className="book-wr">
          {order && (
            <BookDetails
              pax={order.pax}
              price={order.currency + ' ' + order.price}
            />
          )}
        </div>
        <div className="text-center display-ib book-title">
          <div className="text-bold">
            הנפקת ויזה בקלות ובמהירות עם Amsalem VISA
          </div>
          <div>
            קשתכם להנפקת ויזה התקבלה ותועבר לטיפול מהיר ומקצועי על ידי צוות
            מחלקת ויזות שלנו.
          </div>
        </div>
      </div>

      {!!data?.pageContent?.body && (
        <div dangerouslySetInnerHTML={{ __html: data.pageContent.body }}></div>
      )}
    </div>
  );
};

export default SuccessPage;
